export default "__VITE_ASSET__1cbcd076__"